export function exportCsv (rows: Array<Array<string | number | null | undefined>>, fileName: string): void {
    const BOM = '\uFEFF';
    let csvContent = '';

    rows.forEach((row) => {
        row.forEach((cell) => {
            if (typeof cell === 'string') {
                const escaped = cell.replace(/"/g, '""');
                csvContent += `"${escaped}",`;
            } else {
                csvContent += `${cell?.toString() ?? ''},`;
            }
        });
        csvContent += '\n';
    });
    const fullContent = BOM + csvContent;

    const blob = new Blob([fullContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    downloadFileInBrowser(`${fileName} - ${new Date().toLocaleString()}.csv`, url);
}

export function downloadFileInBrowser (filename: string, serialisedFileToDownload: string): void {
    const link = document.createElement('a');
    link.setAttribute('href', serialisedFileToDownload);
    link.setAttribute('download', `${filename}`);
    document.body.appendChild(link); // Required for FF
    link.click();
}
